export const CREATE_UNIT = 'CREATE_UNIT';
export const FETCH_UNITS = 'FETCH_UNITS';
export const FETCH_UNIT = 'FETCH_UNIT';
export const EDIT_UNIT = 'EDIT_UNIT';
export const DELETE_UNIT = 'DELETE_UNIT';
